import { ReportingPeriodsPage } from '@app/ccf/company-report/pages/reporting-periods-page';
import Scope1And2ImportPage from '@app/components/imports/scope-1-2-import/pages/scope-1-2-import-page';
import Scope1And2ImportProcessPage from '@app/components/imports/scope-1-2-import/pages/scope-1-2-import-process-page';
import Scope1And2ImportLayout from '@app/components/imports/scope-1-2-import/scope-1-2-import-layout';
import { CustomRoute } from '@app/components/layout/sidebar/components/route';
import { FEATURES } from '@app/utils/constants';
import { Navigate, Outlet, Route } from 'react-router-dom';
import CcfAccessPage from './ccf-access-page';
import CCFContext from './company-report/ccf-context';
import CCFGuideLayout from './company-report/ccf-guide-layout';
import CCFLayout from './company-report/ccf-layout';
import SupplyChainLogisticsFlows from './company-report/components/scope-3/supply-chain-logistics/supply-chain-logistics-flows';
import DistributionFlowLayout from './company-report/distribution-flow/distribution-flow-layout';
import DistributionFlowAboutClientsPage from './company-report/distribution-flow/pages/distribution-flow-about-clients-page';
import DistributionFlowAddWeightPage from './company-report/distribution-flow/pages/distribution-flow-add-weight-page';
import DistributionFlowEditPage from './company-report/distribution-flow/pages/distribution-flow-edit-page';
import DistributionFlowIntroPage from './company-report/distribution-flow/pages/distribution-flow-intro-page';
import DistributionFlowReviewPage from './company-report/distribution-flow/pages/distribution-flow-review-page';
import ReportHubPage from './company-report/pages/ccf-hub-page';
import CCFListPage from './company-report/pages/ccf-list-page';
import CCFSetupPeriod from './company-report/pages/ccf-setup-period';
import CCFSetupSites from './company-report/pages/ccf-setup-sites';
import CCFSetupWelcome from './company-report/pages/ccf-setup-welcome';
import DirectGasEmissionsPage from './company-report/pages/scope-1/direct-gas-emissions-page';
import MobileCombustionPage from './company-report/pages/scope-1/mobile-combustion-page';
import StationaryCombustionPage from './company-report/pages/scope-1/stationary-combustion-page';
import ElectricityPage from './company-report/pages/scope-2/electricity-page';
import HeatingPage from './company-report/pages/scope-2/heating-page';
import AdditionalCategoryPage from './company-report/pages/scope-3/additional-category-page';
import BusinessTravelPage from './company-report/pages/scope-3/business-travel-page';
import CCFFoodAndDrinkPage from './company-report/pages/scope-3/ccf-food-page';
import PackagingPage from './company-report/pages/scope-3/packaging-page';
import SupplyChainLogisticsPage from './company-report/pages/scope-3/supply-chain-logistics-page';
import ReportPublish from './company-report/publish/report-publish';
import ReportPublishLayout from './company-report/publish/report-publish-layout';
import ReportReviewScope1 from './company-report/publish/report-review-scope-1';
import ReportReviewScope2 from './company-report/publish/report-review-scope-2';
import ReportReviewScope3 from './company-report/publish/report-review-scope-3';
import CCFReport from './company-report/report/ccf-report';
import CCFReportDownload from './company-report/report/ccf-report-download';
import CCFReportContextProvider from './company-report/report/ccf-report-result-context';
import SecrConfigurationPage from './company-report/secr/secr-configuration-page';
import SecrReportDownload from './company-report/secr/secr-report-download';
import SecrReportPage from './company-report/secr/secr-report-page';
import { reportSlugs } from './company-report/slugs';
import SupplyFlowAboutSuppliersPage from './company-report/supply-flow/pages/supply-flow-about-suppliers-page';
import SupplyFlowAddWeightPage from './company-report/supply-flow/pages/supply-flow-add-weight-page';
import SupplyFlowEditPage from './company-report/supply-flow/pages/supply-flow-edit-page';
import SupplyFlowIntroPage from './company-report/supply-flow/pages/supply-flow-intro-page';
import SupplyFlowReviewPage from './company-report/supply-flow/pages/supply-flow-review-page';
import SupplyFlowLayout from './company-report/supply-flow/supply-flow-layout';
import ElectricitySuppliesPage from './sites/pages/electricity-supplies-page';
import SitesPage from './sites/pages/sites-page';
import SitesLayout from './sites/sites-layout';

export const ccfRoutes = {
  COMPANY_REPORTS: '/company-reports',
  COMPANY_REPORT_ACCESS: '/company-reports/access',
  COMPANY_REPORT: '/company-reports/:report_uuid/summary',
  FULL_REPORT: '/company-reports/:report_uuid/report',
  REPORT_DOWNLOAD: '/company-reports/:report_uuid/report/download',
  COMPANY_REPORT_SETUP: '/company-reports/setup',
  COMPANY_REPORT_SETUP_WELCOME: '/company-reports/welcome',
  COMPANY_REPORT_SETUP_SITES: '/company-reports/:report_uuid/sites',

  // Publish / Report
  PUBLISH: '/company-reports/:report_uuid/publish',
  PUBLISH_REVIEW_SCOPE_1:
    '/company-reports/:report_uuid/publish/review-scope-1',
  PUBLISH_REVIEW_SCOPE_2:
    '/company-reports/:report_uuid/publish/review-scope-2',
  PUBLISH_REVIEW_SCOPE_3:
    '/company-reports/:report_uuid/publish/review-scope-3',
  REPORT_RESULT: '/company-reports/:report_uuid/report',

  // CCF Food and drink
  FOOD: '/company-reports/:report_uuid/food',
  PACKAGING: '/company-reports/:report_uuid/packaging',
  // CCF Scope 3 - Supply Chain
  SUPPLY_CHAIN_LOGISTICS:
    '/company-reports/:report_uuid/supply-chain-logistics',

  SUPPLY_CHAIN_LOGISTICS_FLOWS:
    '/company-reports/:report_uuid/supply-chain-logistics/flows',

  OTHER_PURCHASED_GOODS: '/company-reports/:report_uuid/other-purchased-goods',
  CAPITAL_GOODS: '/company-reports/:report_uuid/capital-goods',
  WASTE: '/company-reports/:report_uuid/waste',
  BUSINESS_TRAVEL: '/company-reports/:report_uuid/business-travel',
  EMPLOYEE_COMMUTING: '/company-reports/:report_uuid/employee-commuting',
  LEASED_ASSETS_UPSTREAM:
    '/company-reports/:report_uuid/leased-assets-upstream',
  SOLD_PRODUCTS_PROCESSING:
    '/company-reports/:report_uuid/sold-products-processing',
  SOLD_PRODUCTS_USE: '/company-reports/:report_uuid/sold-products-use',
  SOLD_PRODUCTS_END_OF_LIFE:
    '/company-reports/:report_uuid/sold-products-end-of-life',
  LEASED_ASSETS_DOWNSTREAM:
    '/company-reports/:report_uuid/leased-assets-downstream',
  FRANCHISES: '/company-reports/:report_uuid/franchises',
  INVESTMENTS: '/company-reports/:report_uuid/investments',

  SECR_CONFIGURATION: '/company-reports/:report_uuid/secr-configuration',
  SECR_REPORT: '/company-reports/:report_uuid/secr-report',
  SECR_REPORT_DOWNLOAD: '/company-reports/:report_uuid/secr-report/download',

  // CCF Scope specific
  STATIONARY_COMBUSTION: '/company-reports/:report_uuid/stationary-combustion',
  MOBILE_COMBUSTION: '/company-reports/:report_uuid/mobile-combustion',
  DIRECT_GAS: '/company-reports/:report_uuid/direct-gas',
  ELECTRICITY: '/company-reports/:report_uuid/electricity',
  HEATING: '/company-reports/:report_uuid/heating-and-steam',

  // Scope 1 & 2 Excel importer (per category)
  SCOPE_1_2_IMPORT_PROCESS:
    '/company-reports/:report_uuid/imports/:category_slug/process',
  SCOPE_1_2_IMPORT_UPLOAD:
    '/company-reports/:report_uuid/imports/:category_slug/upload',

  SITES: '/sites',
  ELECTRICITY_SUPPLIES: '/sites/electricity-supplies',
  REPORTING_PERIOD: '/reporting-period',

  // CCF Scope 3 - Distribution and Supply flows
  DISTRIBUTION_OF_PRODUCTS:
    '/company-reports/:report_uuid/distribution-of-products',
  DISTRIBUTION_FLOW_INTRO:
    '/company-reports/:report_uuid/distribution-of-products/intro',
  DISTRIBUTION_FLOW_ABOUT_CLIENTS:
    '/company-reports/:report_uuid/distribution-of-products/about-clients/:flow_uuid?',
  DISTRIBUTION_FLOW_REVIEW:
    '/company-reports/:report_uuid/distribution-of-products/review/:flow_uuid?',
  DISTRIBUTION_FLOW_ADD_WEIGHT:
    '/company-reports/:report_uuid/distribution-of-products/add-weight/:flow_uuid?',

  SUPPLY_OF_PURCHASED_GOODS:
    '/company-reports/:report_uuid/supply-of-purchased-goods',
  SUPPLY_FLOW_INTRO:
    '/company-reports/:report_uuid/supply-of-purchased-goods/intro',
  SUPPLY_FLOW_ABOUT_SUPPLIERS:
    '/company-reports/:report_uuid/supply-of-purchased-goods/about-suppliers/:flow_uuid?',
  SUPPLY_FLOW_REVIEW:
    '/company-reports/:report_uuid/supply-of-purchased-goods/review/:flow_uuid?',
  SUPPLY_FLOW_ADD_WEIGHT:
    '/company-reports/:report_uuid/supply-of-purchased-goods/add-weight/:flow_uuid?',

  DISTRIBUTION_FLOW_EDIT:
    '/company-reports/:report_uuid/distribution-of-products/edit/:flow_uuid',
  SUPPLY_FLOW_EDIT:
    '/company-reports/:report_uuid/supply-of-purchased-goods/edit/:flow_uuid',
};

export function CCFRoutes() {
  return (
    <>
      <Route
        path={ccfRoutes.COMPANY_REPORT_ACCESS}
        element={<CcfAccessPage />}
      />

      <Route
        path={ccfRoutes.COMPANY_REPORTS}
        element={<CustomRoute feature={[FEATURES.ccf]} element={<Outlet />} />}
      >
        <Route index element={<CCFListPage />} />
        <Route
          element={
            <CustomRoute element={<CCFGuideLayout />} hasSidebar={false} />
          }
        >
          <Route
            path={ccfRoutes.COMPANY_REPORT_SETUP_WELCOME}
            element={<CCFSetupWelcome />}
          />
          <Route
            path={ccfRoutes.COMPANY_REPORT_SETUP}
            element={<CCFSetupPeriod />}
          />
        </Route>
        {/* CCF Context Provider */}
        <Route path=":report_uuid" element={<CCFContext />}>
          <Route index element={<Navigate to={ccfRoutes.COMPANY_REPORT} />} />
          {/* Main CCF Report */}
          <Route path="" element={<CCFLayout />}>
            <Route
              path={ccfRoutes.COMPANY_REPORT_SETUP_SITES}
              element={
                <CustomRoute element={<CCFSetupSites />} hasSidebar={false} />
              }
            />
            <Route
              path={ccfRoutes.COMPANY_REPORT}
              element={<ReportHubPage />}
            />
            <Route
              path={ccfRoutes.SECR_CONFIGURATION}
              element={
                <CustomRoute
                  feature={[FEATURES.secr]}
                  element={<SecrConfigurationPage />}
                />
              }
            />
            <Route
              path={ccfRoutes.STATIONARY_COMBUSTION}
              element={<StationaryCombustionPage />}
            />
            <Route
              path={ccfRoutes.MOBILE_COMBUSTION}
              element={<MobileCombustionPage />}
            />
            <Route
              path={ccfRoutes.DIRECT_GAS}
              element={<DirectGasEmissionsPage />}
            />
            <Route path={ccfRoutes.ELECTRICITY} element={<ElectricityPage />} />
            <Route path={ccfRoutes.HEATING} element={<HeatingPage />} />
            <Route path={ccfRoutes.FOOD} element={<CCFFoodAndDrinkPage />} />

            <Route path={ccfRoutes.PACKAGING} element={<PackagingPage />} />

            <Route
              path={ccfRoutes.SUPPLY_CHAIN_LOGISTICS}
              element={<SupplyChainLogisticsPage />}
            />
            <Route
              path={ccfRoutes.OTHER_PURCHASED_GOODS}
              element={
                <AdditionalCategoryPage
                  slug={reportSlugs.otherPurchasedGoods}
                />
              }
            />
            <Route
              path={ccfRoutes.CAPITAL_GOODS}
              element={
                <AdditionalCategoryPage slug={reportSlugs.capitalGoods} />
              }
            />
            <Route
              path={ccfRoutes.WASTE}
              element={<AdditionalCategoryPage slug={reportSlugs.waste} />}
            />
            <Route
              path={ccfRoutes.BUSINESS_TRAVEL}
              element={<BusinessTravelPage />}
            />
            <Route
              path={ccfRoutes.EMPLOYEE_COMMUTING}
              element={
                <AdditionalCategoryPage slug={reportSlugs.employeeCommuting} />
              }
            />
            <Route
              path={ccfRoutes.LEASED_ASSETS_UPSTREAM}
              element={
                <AdditionalCategoryPage
                  slug={reportSlugs.leasedAssetsUpstream}
                />
              }
            />
            <Route
              path={ccfRoutes.SOLD_PRODUCTS_PROCESSING}
              element={
                <AdditionalCategoryPage
                  slug={reportSlugs.soldProductsProcessing}
                />
              }
            />
            <Route
              path={ccfRoutes.SOLD_PRODUCTS_USE}
              element={
                <AdditionalCategoryPage slug={reportSlugs.soldProductsUse} />
              }
            />
            <Route
              path={ccfRoutes.SOLD_PRODUCTS_END_OF_LIFE}
              element={
                <AdditionalCategoryPage
                  slug={reportSlugs.soldProductsEndOfLife}
                />
              }
            />
            <Route
              path={ccfRoutes.LEASED_ASSETS_DOWNSTREAM}
              element={
                <AdditionalCategoryPage
                  slug={reportSlugs.leasedAssetsDownstream}
                />
              }
            />
            <Route
              path={ccfRoutes.FRANCHISES}
              element={<AdditionalCategoryPage slug={reportSlugs.franchises} />}
            />
            <Route
              path={ccfRoutes.INVESTMENTS}
              element={
                <AdditionalCategoryPage slug={reportSlugs.investments} />
              }
            />
          </Route>

          {/* Scope 1 & 2 Excel importer (full-screen, per category) */}
          <Route
            element={
              <CustomRoute
                element={<Scope1And2ImportLayout />}
                hasSidebar={false}
              />
            }
          >
            <Route
              path={ccfRoutes.SCOPE_1_2_IMPORT_PROCESS}
              element={<Scope1And2ImportProcessPage />}
            />
            <Route
              path={ccfRoutes.SCOPE_1_2_IMPORT_UPLOAD}
              element={<Scope1And2ImportPage />}
            />
          </Route>

          {/* Supply chain logistics */}
          <Route
            path={ccfRoutes.SUPPLY_CHAIN_LOGISTICS_FLOWS}
            element={
              <CustomRoute
                element={<SupplyChainLogisticsFlows />}
                hasSidebar={false}
              />
            }
          />
          {/* Distribution of products */}
          <Route
            path={ccfRoutes.DISTRIBUTION_OF_PRODUCTS}
            element={
              <CustomRoute
                element={<DistributionFlowLayout />}
                hasSidebar={false}
              />
            }
          >
            <Route
              path={ccfRoutes.DISTRIBUTION_FLOW_INTRO}
              element={<DistributionFlowIntroPage />}
            />
            <Route
              path={ccfRoutes.DISTRIBUTION_FLOW_ABOUT_CLIENTS}
              element={<DistributionFlowAboutClientsPage />}
            />
            <Route
              path={ccfRoutes.DISTRIBUTION_FLOW_REVIEW}
              element={<DistributionFlowReviewPage />}
            />
            <Route
              path={ccfRoutes.DISTRIBUTION_FLOW_ADD_WEIGHT}
              element={<DistributionFlowAddWeightPage />}
            />
            <Route
              path={ccfRoutes.DISTRIBUTION_FLOW_EDIT}
              element={<DistributionFlowEditPage />}
            />
          </Route>
          {/* Supply of purchased goods */}
          <Route
            path={ccfRoutes.SUPPLY_OF_PURCHASED_GOODS}
            element={
              <CustomRoute element={<SupplyFlowLayout />} hasSidebar={false} />
            }
          >
            <Route
              path={ccfRoutes.SUPPLY_FLOW_INTRO}
              element={<SupplyFlowIntroPage />}
            />
            <Route
              path={ccfRoutes.SUPPLY_FLOW_ABOUT_SUPPLIERS}
              element={<SupplyFlowAboutSuppliersPage />}
            />
            <Route
              path={ccfRoutes.SUPPLY_FLOW_REVIEW}
              element={<SupplyFlowReviewPage />}
            />
            <Route
              path={ccfRoutes.SUPPLY_FLOW_ADD_WEIGHT}
              element={<SupplyFlowAddWeightPage />}
            />
            <Route
              path={ccfRoutes.SUPPLY_FLOW_EDIT}
              element={<SupplyFlowEditPage />}
            />
          </Route>

          {/* SECR Report */}
          <Route
            path={ccfRoutes.SECR_REPORT}
            element={
              <CustomRoute
                feature={[FEATURES.secr]}
                element={<SecrReportPage />}
                hasSidebar={false}
              />
            }
          />
          <Route
            path={ccfRoutes.SECR_REPORT_DOWNLOAD}
            element={
              <CustomRoute
                feature={[FEATURES.secr]}
                element={<SecrReportDownload />}
                hasSidebar={false}
              />
            }
          />

          {/* CCF Report */}
          <Route
            path="publish"
            element={
              <CustomRoute
                element={<ReportPublishLayout />}
                hasSidebar={false}
              />
            }
          >
            <Route index element={<ReportPublish />} />
            <Route
              path={ccfRoutes.PUBLISH_REVIEW_SCOPE_1}
              element={<ReportReviewScope1 />}
            />
            <Route
              path={ccfRoutes.PUBLISH_REVIEW_SCOPE_2}
              element={<ReportReviewScope2 />}
            />
            <Route
              path={ccfRoutes.PUBLISH_REVIEW_SCOPE_3}
              element={<ReportReviewScope3 />}
            />
          </Route>
        </Route>
      </Route>

      <Route
        path={ccfRoutes.FULL_REPORT}
        element={
          <CustomRoute
            feature={[FEATURES.ccf]}
            element={<CCFReportContextProvider />}
            hasSidebar={false}
          />
        }
      >
        <Route index element={<CCFReport />} />
        <Route
          path={ccfRoutes.REPORT_DOWNLOAD}
          element={<CCFReportDownload />}
        />
      </Route>

      <Route path={ccfRoutes.SITES} element={<SitesLayout />}>
        <Route index element={<SitesPage />} />
        <Route
          path={ccfRoutes.ELECTRICITY_SUPPLIES}
          element={<ElectricitySuppliesPage />}
        />
      </Route>

      <Route
        path={ccfRoutes.REPORTING_PERIOD}
        element={
          <CustomRoute element={<ReportingPeriodsPage />} hasSidebar={false} />
        }
      />
    </>
  );
}
